import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import './typekit';
import { light } from '../data/themes'; // Need to use a theme here for this but don't have provider, could do better

import latoBold from '../fonts/Lato-Bold.ttf';
import latoRegular from '../fonts/Lato-Regular.ttf'; // There are some styles that we want to apply globally
// For example, we want to set the base REM size and fonts

var globalCss = "\n  @font-face {\n    font-family: 'Lato';\n    src: url('".concat(latoBold, "') format('truetype'), ").concat(light.fontFamilySansSerif, ";\n    font-weight: bold;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: 'Lato';\n    src: url('").concat(latoRegular, "') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  html {\n    font-family: ", "Lato, ".concat(light.fontFamilySansSerif), ";\n    font-size: ").concat(light.remSize, "\n  }\n");

var Theme = function Theme(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  useEffect(function () {
    var id = 'ui-global-styles';

    if (typeof document !== "undefined") {
      var existingEl = document.getElementById(id);

      if (!existingEl) {
        /* eslint-disable fp/no-mutation */
        var el = document.createElement('style');
        el.id = id;
        el.type = 'text/css';
        /* eslint-enable fp/no-mutation */

        el.appendChild(document.createTextNode(globalCss));
        document.body.appendChild(el);
      }
    }
  });
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children);
};

export default Theme;